import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForTerminationContractForm } from "../../../components/create-application-for-termination-contract-form";
import { useAFLRequest } from "../../../hooks";
const dataFallback = {};

export const TerminationContractEdit = withProcedureWraper(() => {
  const { data = dataFallback, isLoading: isRequestLoading, isFetching: isRequestFetching, isError } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  return (
    <ProcedureLayout title="Chỉnh sửa đơn xin chấm dứt hợp đồng lao động" loading={isRequestFetching}>
      <CreateApplicationForTerminationContractForm data={data} />
    </ProcedureLayout>
  );
});
